import styled from "styled-components";

export const InfoBubbleContainer = styled.div`
  display: flex;
  background-color: #ececec;
  width: 100%;
  height: auto;
  justify-content: center;
  align-items: center;
  height: fit-content;
  border-radius: 10px;
  flex-direction: row;
  margin-top: 20px;
  flex-direction: column;
  padding: 10px;
  box-shadow: ${({ theme }) => theme.shadows.light.medium};
`;

export const InfoBubbleTitle = styled.div`
  display: flex;
  flex: 0.1;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
`;

export const InfoBubbleDescription = styled.div`
  display: flex;
  flex: 0.9;
  width: 100%;

  height: fit-content;
  align-items: center;
  padding-right: 10px;

  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
`;
